import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Our_Doctor.css";
import Common_title from "../../common-components/common_title/Common_title";

const Our_Doctor = () => {
  return (
    <>
      <div className="doctor_title_holder">
        <Common_title text="⚓ MEET OUR DOCTOR" />
      </div>
      <section className="our_doctor_section">
        <Container>
          <div className="section_holder">
            <Row className="align-items-center">
              <Col lg={4}>
                <div className="doctor_img_holder">
                  <img
                    src="/assets/images/about_us/doctor.jpeg"
                    alt="doctor-img"
                    className="doctor_img"
                  />
                </div>
              </Col>
              <Col lg={8}>
                <div className="doctor_text_holder">
                  <h2 className="doctor_title">
                    Dr. (Mrs.) Pradnya Vinod Gawande
                  </h2>

                  <p className="doctor_subtitle">
                    DG Approved Medical Examiner | Consultant in Family &
                    Occupational Medicine
                  </p>

                  <div className="approval_no_holder">
                    <p className="approval_no">
                      DGS Approval No. : MAH/PN/16/2017
                    </p>
                  </div>

                  <p className="doctor_text">
                    With over 11 years of maritime medical experience, Dr.
                    Pradnya Gawande has been conducting medical examinations for
                    seafarers from leading national and international shipping
                    companies since 2014.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Our_Doctor;
